export default "__VITE_ASSET__CaSo2vWr__"